var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('previewHeaderComponent',{attrs:{"title":_vm.$t('object.org.name')},on:{"back":_vm.goBack}}),_c('adminFormComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }